import React from "react"
import ReactDOM from "react-dom/client"
import App from "./App"
import { storage } from "./utils/storage"
import { applyTheme, resolveSystemTheme } from "./utils/theme"
import "./styles/theme.css"
import "./styles/globals.css"

const storedTheme = storage.getTheme()
if (storedTheme === "dark" || storedTheme === "light") {
  applyTheme(storedTheme)
} else {
  applyTheme(resolveSystemTheme())
}

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(<App />)
